import React from "react";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import { DropdownWrapper } from "../dropdowns/dropdownWrapper/DropdownWrapper";
import "./multiSelect.scss";
import { type DropdownItemProps, type DropdownProps } from "semantic-ui-react";

export type MultiSelectItem<S = string | number> = {
  text: string | React.ReactNode;
  value: S;
  key?: string;
};

export interface MultiSelectProps<S> {
  items: MultiSelectItem<S>[] | null;
  selected?: S[];
  onMultiSelectChange: (data: { value: S[] }) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
  search?: (list: DropdownItemProps[], searchString: string) => DropdownItemProps[];

  [key: string]: unknown;
}

export function MultiSelect<S extends string | number>(props: MultiSelectProps<S>) {
  const { placeholder, items, selected, onMultiSelectChange, className, ...additionalProps } = props;

  let options = items || [];
  const { propertyName, updateFilter, disabled, ...remainingProps } = additionalProps;

  if (isEmpty(items) && isArray(selected)) {
    options = selected.map((x) => ({ text: String(x), value: x }));
  }

  const handleChange = (_: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
    onMultiSelectChange(data as { value: S[] });
  };

  return (
    <DropdownWrapper
      className={className}
      multiple
      selection
      // Allows for custom search functionality if provided
      search={!disabled && props.search ? props.search : !disabled}
      disabled={disabled}
      fluid
      selected={selected}
      items={options}
      handleOptionChange={handleChange}
      placeholder={placeholder}
      {...remainingProps}
    />
  );
}

MultiSelect.defaultProps = {
  placeholder: "",
  items: [],
  selected: [],
};
